import Quill from '../core/quill';
import Delta from 'quill-delta';
import extend from 'extend';
import BubbleTheme, {BubbleTooltip} from './bubble';
import TextLine from '../formats/textLine';
import TextBreak from '../blots/textBreak';
import Divider from '../blots/divider';
import Figure from '../modules/figure';

BubbleTooltip.TEMPLATE = [
  '<span class="ql-tooltip-arrow"></span>',
  '<div class="ql-tooltip-editor">',
  '<input type="text" data-formula="e=mc^2" data-link="https://example.com" data-video="Embed URL">',
  '<a class="ql-close"></a>',
  '</div>',
].join('');

const CLIPBOARD_CONFIG = [
  ['img', function (node) {
    if (node.src && sanitize(node.src, ['http', 'https', 'data'])) {
      node.src = node.src.replace(location.origin, '');
      return new Delta().insert({
        figure: {
          image: node.src,
          caption: node.alt || '',
          source: node.dataset.source || ''
        }
      });
    }
    return new Delta();
  }],
  ['video', function (node) {
    if (node.src && sanitize(node.src, ['http', 'https', 'data'])) {
      return new Delta().insert({figure: {video: node.src}});
    }
    return new Delta();
  }],
];

class MaptiaTheme extends BubbleTheme {
  constructor(quill, options) {
    super(quill, options);
    
    Quill.register({
      'blots/textBreak': TextBreak,
      'blots/divider': Divider,
      
      'formats/textLine': TextLine,
  
      'modules/figure': Figure,
    });
  
    options.modules = extend({}, {
      storage: true,
      figure: {
        buttons: false,
        caption: true,
      },
    }, options.modules || {});
    
    quill.on(Quill.events.SCROLL_OPTIMIZE, function (mutations) {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && !mutation.addedNodes.length && mutation.removedNodes.length) {
          let prev = mutation.previousSibling;
          let next = mutation.nextSibling;
          // if (!next && prev && prev.tagName === 'BR' && prev.className === 'inline') {
          //   let br = document.createElement('br');
          //   br.className = 'inline';
          //   mutation.target.appendChild(br);
          // } else
          if (next && prev &&
            !(prev.tagName === 'BR' && prev.className === 'inline') &&
            (next.tagName === 'BR' && next.className === 'inline') &&
            !next.nextSibling) {
            if (next.parentNode) {
              next.parentNode.removeChild(next);
            }
          }
        }
      });
    });
    
    // quill.root.classList.add('entry-content');
  }
  
  extendToolbar(toolbar) {
    super.extendToolbar(toolbar);
  
    CLIPBOARD_CONFIG.forEach(
      ([selector, matcher]) => {
        this.quill.clipboard.addMatcher(selector, matcher);
      },
    );
  }
}

MaptiaTheme.DEFAULTS = extend(true, {}, BubbleTheme.DEFAULTS, {
  modules: {
    toolbar: {
      container: [
        ['bold', 'italic', 'link'],
        [{'header': 2}, {'header': 3}, 'blockquote'],
        ['clean']
      ]
    },
  }
});

function sanitize(url, protocols) {
  let anchor = document.createElement('a');
  anchor.href = url;
  let protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

export default MaptiaTheme;
